import React, { Component } from "react";
import { ReactComponent as Page } from "../../assets/images/empty-page-while-loading.svg";
import { AppContext, DetailsPageAnimationWrapper } from "../../App";

class EmptyPageWhileLoadingInner extends Component {
	componentDidMount() {
		this.props.updatePageDimensions(1010, 456);
	}
	render() {
		return <Page />;
	}
}

class EmptyPageWhileLoading extends React.Component {
	render() {
		return (
			<DetailsPageAnimationWrapper>
				<AppContext.Consumer>
					{({ updatePageDimensions }) => (
						<EmptyPageWhileLoadingInner
							updatePageDimensions={updatePageDimensions}
							{...this.props}
						/>
					)}
				</AppContext.Consumer>
			</DetailsPageAnimationWrapper>
		);
	}
}

export default EmptyPageWhileLoading;
